import React from "react";
import { useNavigate } from "react-router-dom";
import { Badge } from "@/lib/ui";
import { mediaUrl, money } from "@/lib/api";

export default function ProductCard({ p }) {
  const nav = useNavigate();
  return (
    <div
      data-testid={`product-card-${p.id}`}
      onClick={() => nav(`/product/${p.id}`)}
      className="group cursor-pointer overflow-hidden rounded-xl border border-slate-200 bg-white transition hover:-translate-y-0.5 hover:shadow-md fade-up"
    >
      <div className="relative aspect-square overflow-hidden bg-slate-100">
        <img
          src={mediaUrl(p.catalogue_image)}
          alt={p.product}
          className="h-full w-full object-cover transition group-hover:scale-105"
          loading="lazy"
        />
        {p.discount > 0 && (
          <span className="absolute left-2 top-2 rounded-full bg-orange-600 px-2 py-0.5 text-xs font-extrabold text-white shadow">
            {p.discount}% OFF
          </span>
        )}
        {p.pan_india && (
          <span className="absolute right-2 top-2 rounded-full bg-slate-900/85 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white">
            Pan India
          </span>
        )}
      </div>
      <div className="p-3">
        <p className="line-clamp-1 font-head text-sm font-bold text-slate-900">{p.product}</p>
        <p className="mt-0.5 text-xs text-slate-500">{p.size} · {p.condition}{p.quality ? ` · ${p.quality}` : ""}</p>

        <div className="mt-2 flex items-baseline gap-2">
          <span className="font-head text-lg font-extrabold text-slate-900">{money(p.primary_rate)}</span>
          <span className="text-xs text-slate-400">/ {p.primary_unit}</span>
        </div>
        {p.actual_rate > p.primary_rate && (
          <span className="strike text-xs text-slate-400">{money(p.actual_rate)} / {p.primary_unit}</span>
        )}
        {p.secondary_unit && p.secondary_rate > 0 && (
          <p className="text-xs font-semibold text-slate-600">{money(p.secondary_rate)} / {p.secondary_unit}</p>
        )}

        <div className="mt-2 flex flex-wrap items-center gap-1.5 text-[11px] text-slate-500">
          <span><i className="fa-solid fa-cubes mr-1 text-slate-400" />{p.quantity} {p.primary_unit}s</span>
          {p.moq ? <span>· MOQ {p.moq}</span> : <span>· No MOQ</span>}
        </div>
        <div className="mt-2 flex items-center justify-between">
          <span className="text-xs font-medium text-slate-600">
            <i className="fa-solid fa-location-dot mr-1 text-orange-500" />{p.city}
          </span>
          {p.seller_badge && <Badge tone="emeraldSoft"><i className="fa-solid fa-circle-check" /> Verified</Badge>}
        </div>
      </div>
    </div>
  );
}
